import React from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'
import Address from '../../address/Address'
const {
  constants: { SUPPORTED_CHECK_COUNTRIES },
} = require('@plastiq/external-api-validation')

// TODO see if we can leverage a path alias for the base directory or root/src
import TextInput from '../../../../base/TextInput/TextInput'
import { inputProperties } from '../../../../types/inputProperties'

export interface CheckDeliveryMethodProps {
  city?: inputProperties
  country?: inputProperties
  form?: UseFormReturn
  instructionLabel?: string
  line1?: inputProperties
  line2?: inputProperties
  name?: inputProperties
  payableTo?: inputProperties
  postalCode?: inputProperties
  state?: inputProperties
}

const CheckDeliveryMethod = (props: CheckDeliveryMethodProps) => {
  const useFormDefault = props.form || useForm()
  useFormDefault.setValue('type', 'CHECK')

  Object.assign(CheckDeliveryMethod.defaultProps.payableTo, props.payableTo)

  // List of check supported countries ['US', 'CA', 'PR']
  const supportedCheckCountriesAbbreviation: Array<string> =
    SUPPORTED_CHECK_COUNTRIES.map(
      (country: { abbreviation: string }) => country?.abbreviation,
    )

  const payableTo = useFormDefault.getValues('payableTo')
  return (
    <>
      {payableTo && (
        <TextInput
          form={useFormDefault}
          disabled={true}
          {...CheckDeliveryMethod.defaultProps.payableTo}
        />
      )}
      <Address
        form={useFormDefault}
        country={props.country}
        line1={props.line1}
        line2={props.line2}
        city={props.city}
        state={props.state}
        postalCode={props.postalCode}
        supportedCountriesAbbreviation={supportedCheckCountriesAbbreviation}
      />
    </>
  )
}

CheckDeliveryMethod.defaultProps = {
  payableTo: {
    label: 'Check Payable To',
    name: 'payableTo',
  },
  type: {
    label: 'Delivery Type',
    name: 'type',
    required: true,
  },
  instructionLabel:
    'Send check using standard mail within 8 business days. No Fees.',
}

export default CheckDeliveryMethod
